
























































import { Component } from 'vue-property-decorator';
import {
  DamageModel,
  DamageRegulationType,
  DamageStatus,
  ITag,
  IUser,
  TagCategory,
} from 'admiral-core';
import { XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal } from 'bootstrap-vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import DamageForm from '@/forms/DamageForm.vue';
import { DamageApi } from '@/services/DamageApi';
import { TagApi } from '@/services/TagApi';
import FormInput from '@/components/common/forms/FormInput.vue';

@Component({
  components: {
    FormSubmit,
    DamageForm,
    XIcon,
  },
})
export default class CreateDamageModal extends mixins(BaseMixin, FormMixin) {
  model = this.defaultModel();
  tags: ITag[] = [];

  defaultModel(): DamageModel {
    return {
      customer: '',
      product: undefined,
      policyNumber: '',
      affectedItem: '',
      location: '',
      value: undefined,
      // date: new Date(),
      description: '',
      dueAt: undefined,
      regulationType: DamageRegulationType.CENTRAL,
      user: { id: '' } as IUser, // Explizit auf "Nicht zugewiesen" setzen
      status: DamageStatus.NEW,
      tags: [],
      newUploadedFiles: [],
      files: [],
      newComments: [],
    };
  }

  async mounted() {
    // focus "customer"
    (this.$refs['create-damage'] as BModal).$on('shown', async () => {
      (
        ((this.$refs['damage-form'] as DamageForm).$refs['customer'] as FormInput)
          .$el as HTMLInputElement
      ).focus();

      await this.loadTags();
    });
  }

  async destroyed() {
    // Event-Listener entfernen, um Memory-Leaks zu vermeiden
    if (this.$refs['create-damage']) {
      (this.$refs['create-damage'] as BModal).$off('shown');
    }
  }

  async ok(evt: Event) {
    evt.preventDefault();

    try {
      this.isLoading = true;
      this.resetErrors();

      // Validierung: Customer ist required
      if (!this.model.customer || this.model.customer.trim() === '') {
        this.addError(true, 'customer', 'Bitte geben Sie einen Kunden an');
        this.isLoading = false;
        return;
      }

      // Behandeln Sie den Fall, wenn user nicht zugewiesen ist
      let userToSend: IUser | undefined = this.model.user;
      if (!userToSend || !userToSend.id || userToSend.id === '') {
        userToSend = undefined; // Verwenden Sie undefined statt eines leeren Objekts
      }

      const damageForm = this.$refs['damage-form'] as DamageForm;
      const commentbox = damageForm.$refs['commentbox'] as any;
      if (commentbox.value?.text) {
        this.model.newComments!.push({
          id: 'new-comment',
          text: commentbox.value?.text,
          createdAt: new Date(),
          updatedAt: new Date(),
          user: this.user!,
          isDemo: false,
        });
        commentbox.resetComment();
      }

      const response = await DamageApi.create({
        agency: this.agency,
        customer: this.model.customer,
        product: this.model.product,
        policyNumber: this.model.policyNumber,
        affectedItem: this.model.affectedItem,
        location: this.model.location,
        value: this.model.value ? Number(this.model.value) : undefined,
        date: this.model.date,
        description: this.model.description,
        dueAt: this.model.dueAt,
        regulationType: this.model.regulationType,
        user: userToSend, // Verwenden Sie die bereinigte Version
        tags: this.model.tags,
        tasks: this.model.tasks || [],
        status: this.model.status || DamageStatus.NEW,
        newUploadedFiles: this.model.newUploadedFiles,
        newComments: this.model.newComments,
      });

      this.$toastr.s(
        `Schaden für ${this.model.customer} erfolgreich angelegt.`,
        'Schaden angelegt',
      );

      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$emit('create-damage', response.data);
      this.$nextTick(() => {
        (this.$refs['create-damage'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);
      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Schadens ist etwas schief gelaufen.');
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(
      apiErrors['customerisNotEmpty'] || apiErrors['customerminLength'],
      'customer',
      'Bitte geben Sie einen gültigen Kunden an',
    );
  }

  async loadTags() {
    try {
      const response = await TagApi.getTags({
        agency: this.user.agency,
        category: TagCategory.Damages,
      });
      this.tags = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  cancel() {
    this.model = this.defaultModel();
    this.errors = {};
    (this.$refs['create-damage'] as BModal).hide();
  }
}
